import React from 'react';
import styled from 'styled-components';
import { Container, Nav, Navbar } from 'react-bootstrap';

const StyledNavbar = styled(Navbar)`
    background: white;
    z-index: 2;
    &&& {
        // Custom styles can be added here
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const StyledContainer = styled(Container)`
    &&& {
        z-index: 1;
    }

    @media (max-width: 768px) {
        // Optional: Add styles for mobile view if needed
    }
`;

const StyledNav = styled(Nav)`
    &&& {
        font-family: Poppins, sans-serif;
        display: flex;
        justify-content: center;
        width: 100%;

        @media (max-width: 768px) {
            justify-content: center; /* Center items on small screens */
            text-align: center;
        }
    }
`;

const StyledNavLink = styled(Nav.Link)`
    &&& {
        color: black;
        margin-right: 10px;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 14px;
        color: #b01116;
        text-decoration: none;
    }

    @media (max-width: 768px) {
        text-align: left;
        margin-right: 0;
    }
`;

const StyledNavbarCollapse = styled(Navbar.Collapse)`
    flex-direction: column;
    align-items: self-start;
    margin-left: 150px;

    @media (max-width: 600px) {
        margin: 0 !important;

        a {
            text-align: center;
        }
    }
`;

export default function NavbarComponent() {

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      };

    return (
        <StyledNavbar expand="lg">
            <StyledContainer>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <StyledNavbarCollapse id="basic-navbar-nav">
                    <StyledNav className="justify-content-center">
                        <StyledNavLink href="https://www.homecredit.ph/" target="_blank">HOME CREDIT WEBSITE</StyledNavLink>
                        <StyledNavLink href="https://bpims.com/" target="_blank">BPI MS INSURANCE WEBSITE</StyledNavLink>
                        <StyledNavLink href="https://bit.ly/HomeProtectionTC" target="_blank">TERMS AND CONDITIONS</StyledNavLink>
                        <StyledNavLink onClick={() => scrollToElement('contact-us')}>
                            CONTACT
                        </StyledNavLink>
                    </StyledNav>
                </StyledNavbarCollapse>
            </StyledContainer>
        </StyledNavbar>
    );
}
